import React, { useContext } from 'react'
import {RecipeConText} from "../../../../../context/RecipeContext";
import { Form, InputNumber} from "antd";

const  RecipeProductionRatio = ({rowId}) => {

    const [form] = Form.useForm()
    const {productionData} = useContext(RecipeConText)
    const [productionCosts, setProductionCosts] = productionData

    const handleRatioChange = (list) => {
        let mockProduction = Object.assign({}, productionCosts)
        mockProduction[rowId].ratio = list.ratio
        setProductionCosts(mockProduction)
    }

    return(
        <React.Fragment>
            <Form
                form={form}
                wrapperCol={{span:24}}
            >
                <Form.Item
                    name={'ratio'}
                    initialValue={productionCosts[rowId].ratio}
                >
                    <InputNumber
                        step={0.1}
                        onChange={() => handleRatioChange(form.getFieldsValue())}
                    />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default RecipeProductionRatio